import { getTemplateTagLabel, type TemplateTag } from 'src/data/template';

/**
 * Sidebar tab types
 * @enum {string}
 * @property {SIDEBAR_TAB_TYPE} DEFAULT - default generation tool
 */
export const SIDEBAR_TAB_TYPE = {
  all: 'all',
  recentlyUsed: 'recently_used',
  savedTemplates: 'saved_templates',
  templateTag: 'template_tag',
} as const;

export const DEFAULT_SIDEBAR_TAB_TYPE = SIDEBAR_TAB_TYPE.recentlyUsed;

export const SIDEBAR_TAB_ALL = {
  type: SIDEBAR_TAB_TYPE.all,
  label: 'All',
};
export const SIDEBAR_TAB_RECENTLY_USED = {
  type: SIDEBAR_TAB_TYPE.recentlyUsed,
  label: 'Recently used',
};
export const SIDEBAR_TAB_SAVED_TEMPLATES = {
  type: SIDEBAR_TAB_TYPE.savedTemplates,
  label: 'Your saved templates',
};

export const createSidebarTemplateTagTab = (templateTag: TemplateTag) => ({
  type: SIDEBAR_TAB_TYPE.templateTag,
  templateTag,
  label: getTemplateTagLabel(templateTag),
});
